<template>
  <section class="auth-card" :aria-labelledby="headingId">
    <h1 :id="headingId"><slot name="title" /></h1>
    <p v-if="$slots.intro" class="intro"><slot name="intro" /></p>
    <slot />
  </section>
</template>
<script setup lang="ts">
defineProps({ headingId: { type: String, default: "auth-heading" } });
</script>
<style scoped>
.auth-card {
  box-sizing: border-box;
  width: min(100%, 35rem);
  margin: auto;
  padding: clamp(1.25rem, 4vw, 2.5rem);
  background: #fff;
  border: 1px solid #d8dbe2;
  border-radius: 0.5rem;
  box-shadow: 0 0.75rem 2rem rgba(7, 28, 57, 0.09);
  color: #071c39;
}
.auth-card h1 {
  font-size: clamp(1.75rem, 5vw, 2.5rem);
  line-height: 1.1;
  margin: 0 0 0.75rem;
}
.intro {
  line-height: 1.55;
  margin: 0 0 1.5rem;
  color: #465166;
}
</style>
